export default values => ({
  rate: values ? values.rate : null
});
